import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { ListboxModule } from 'primeng/listbox';
import { TableModule } from 'primeng/table';
import { FormgenModule } from '../../libraries/formgen/formgen.module';
import { LibrariesModule } from '../../libraries/libraries.module';
import { SharedModule } from '../../libraries/shared.module';
import { RequestFakturListComponent } from './list/request-faktur-list.component';
import { RequestFakturRestService } from './request-faktur-rest.service';
import { RequestFakturRoutingModule } from './request-faktur-routing.module';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { ChipComponent } from './components/chip/chip.component';
import { AddModalComponent } from './add-modal/add-modal.component';
import { DetailModalComponent } from './detail/detail-modal.component';
import { ShippingModalComponent } from './shipping/shipping-modal.component';
import { StatusInfoModal } from './status-info-modal/status-info-modal.component';
import { AccordionComponent } from './components/accordion/accordion.component';
import { ModalComponent } from './components/modal/modal.component';
import { ReturnModalComponent } from './return/return-modal.component';

export const PROVIDERS = [RequestFakturRestService];

@NgModule({
  imports: [
    RequestFakturRoutingModule,
    BsDropdownModule,
    CommonModule,
    FlexLayoutModule,
    FormgenModule,
    FormsModule,
    ListboxModule,
    LibrariesModule,
    PaginationModule,
    ReactiveFormsModule,
    RouterModule,
    SharedModule,
    TableModule,
    TranslateModule,
    DialogModule,
    ButtonModule
  ],
  declarations: [ChipComponent, AddModalComponent, DetailModalComponent, ShippingModalComponent, StatusInfoModal, AccordionComponent, ModalComponent, ReturnModalComponent, RequestFakturListComponent]
})
export class RequestFakturModule {}
